export default __webpack_public_path__ + "static/img_welfare_5@2x-e5a3657c46b2cafb0dac2c05d6a7c8e2.jpg";